<template>
  <v-dialog v-model="dialog" max-width="450" persistent>
    <v-card>
      <v-card-text class="text-h6 pt-6" style="text-align: center">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          {{ __("Fechar", "schedulings") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],
  data() {
    return {
      dialog: false,
      message: "",
    };
  },
  methods: {
    open(message) {
      this.message = message;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
